<section class="table-page fise-form-modal fise-server-modal">
  <header class="fise-form-modal__header">
    <div class="fise-form-modal__title-wrap">
      <div class="fise-form-modal__icon">
        <mat-icon>dns</mat-icon>
      </div>
      <div>
        <h2>{{ tituloOperacion }} servidor</h2>
        <p>Información y usuarios asignados al servidor</p>
      </div>
    </div>

    <button type="button" mat-icon-button class="fise-form-modal__close" (click)="onClicCerrarModal()" aria-label="Cerrar modal">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <div class="fise-form-modal__body">
    <section class="fise-server-modal__section" [class.is-expanded]="seccionActiva === 'servidor'">
      <button type="button" class="fise-server-modal__section-toggle" (click)="abrirSeccion('servidor')" [attr.aria-expanded]="seccionActiva === 'servidor'">
        <mat-icon>dns</mat-icon>
        <span>Datos del servidor</span>
        <mat-icon class="fise-server-modal__section-chevron">{{ seccionActiva === 'servidor' ? 'expand_less' : 'expand_more' }}</mat-icon>
      </button>

      <form *ngIf="seccionActiva === 'servidor'" class="fise-server-modal__form" [formGroup]="formGroupServidor">
        <mat-form-field appearance="outline">
          <mat-label>Dirección IP</mat-label>
          <input aria-label="Dirección IP" matInput type="text" id="ip" name="ip" [(ngModel)]="objectServidor.ip" formControlName="controlIp" maxlength="15" soloip oninput="this.value = this.value.trim()">
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Sistema operativo</mat-label>
          <input aria-label="Sistema operativo" matInput type="text" id="sistemaOp" name="sistemaOp" [(ngModel)]="objectServidor.so" formControlName="controlSOperativo" maxlength="25" oninput="this.value = this.value.trimLeft()">
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Ubicación</mat-label>
          <input aria-label="Ubicación" matInput type="text" id="ubi" name="ubi" maxlength="60" [(ngModel)]="objectServidor.ubicacion" formControlName="controlUbicacion" oninput="this.value = this.value.trimLeft()">
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Descripción</mat-label>
          <input aria-label="Descripción" matInput type="text" id="desc" name="desc" maxlength="60" [(ngModel)]="objectServidor.descripcion" formControlName="controlDescripcion" oninput="this.value = this.value.trimLeft()">
        </mat-form-field>

        <div class="fise-form-modal__radio-group fise-server-modal__type">
          <span>Tipo de servidor</span>
          <mat-radio-group aria-label="Tipo de servidor" [(ngModel)]="objectServidor.tipoServidor" formControlName="controlTipo" required>
            <mat-radio-button value="Fisico">Físico</mat-radio-button>
            <mat-radio-button value="Virtual">Virtual</mat-radio-button>
          </mat-radio-group>
        </div>
      </form>
    </section>

    <section class="fise-server-modal__section fise-server-modal__users-section" [class.is-expanded]="seccionActiva === 'usuarios'">
      <div class="fise-server-modal__section-header">
        <button type="button" class="fise-server-modal__section-toggle fise-server-modal__section-toggle--label" (click)="abrirSeccion('usuarios')" [attr.aria-expanded]="seccionActiva === 'usuarios'">
          <mat-icon>group</mat-icon>
          <span>Usuarios</span>
        </button>
        <button *ngIf="seccionActiva === 'usuarios' && !mostrarFormularioUsuario" type="button" mat-raised-button class="fise-server-modal__add-user" (click)="onClicAgregarUsuario(true)">
          <mat-icon>add</mat-icon>
          Agregar usuario
        </button>
        <button type="button" class="fise-server-modal__section-toggle fise-server-modal__section-toggle--chevron" (click)="abrirSeccion('usuarios')" [attr.aria-expanded]="seccionActiva === 'usuarios'" aria-label="Mostrar u ocultar usuarios">
          <mat-icon class="fise-server-modal__section-chevron">{{ seccionActiva === 'usuarios' ? 'expand_less' : 'expand_more' }}</mat-icon>
        </button>
      </div>

      <div *ngIf="seccionActiva === 'usuarios' && mostrarFormularioUsuario" class="fise-server-modal__user-form">
        <div class="fise-server-modal__user-form-title">
          <span>Agregar usuario</span>
          <span>Complete los datos para asignarlo al servidor.</span>
        </div>
        <form class="fise-server-modal__form" [formGroup]="formGroupUsuario">
          <mat-form-field appearance="outline">
            <mat-label>Nombre de usuario</mat-label>
            <input aria-label="Nombre de usuario" matInput type="text" id="us" name="us" [(ngModel)]="objectUusuario.usuario" formControlName="controlUs" maxlength="30" oninput="this.value = this.value.trim()" soloLetraEspacioNumeroAcento required>
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Contraseña</mat-label>
            <input aria-label="Contraseña" matInput notCopyPaste type="password" id="contrasenia" name="contrasenia" [(ngModel)]="objectUusuario.password" formControlName="controlPass" maxlength="100" oninput="this.value = this.value.trim()" required>
            <mat-error *ngIf="formUser.controlPass.dirty && formUser.controlPass.errors">La contraseña es obligatoria.</mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Descripción</mat-label>
            <input aria-label="Descripción" matInput type="text" name="descripcion" [(ngModel)]="objectUusuario.descripcion" formControlName="controlDesc" maxlength="100" oninput="this.value = this.value.trimLeft()">
          </mat-form-field>

          <div class="fise-form-modal__radio-group">
            <span>Privilegios</span>
            <mat-radio-group aria-label="Privilegios de usuario" [(ngModel)]="objectUusuario.tipo_usuario" formControlName="controlTipoU" required>
              <mat-radio-button value="Admin">Administrador</mat-radio-button>
              <mat-radio-button value="Usuario">Usuario</mat-radio-button>
            </mat-radio-group>
          </div>
        </form>

        <div class="fise-server-modal__inline-actions">
          <button type="button" mat-raised-button class="app-form-btn app-form-btn--secondary fise-form-modal__cancel" (click)="onClicAgregarUsuario(false)">Cancelar</button>
          <button type="button" mat-raised-button class="app-form-btn app-form-btn--primary fise-form-modal__save" (click)="onClicAddUS()" [disabled]="formGroupUsuario.invalid">
            <mat-icon>add</mat-icon>
            Agregar
          </button>
        </div>
      </div>

      <div *ngIf="seccionActiva === 'usuarios' && !mostrarFormularioUsuario" class="fise-server-modal__table-wrap">
        <table class="table-page__table">
          <thead>
            <tr>
              <th>Usuario</th>
              <th>Contraseña</th>
              <th>Privilegios</th>
              <th class="table-page__actions">Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let usuarioBean of listUsuarios">
              <td>{{ usuarioBean.usuario }}</td>
              <td>{{ usuarioBean.password }}</td>
              <td>{{ usuarioBean.tipo_usuario }}</td>
              <td class="table-page__actions">
                <button type="button" mat-icon-button class="fise-server-modal__delete-user" (click)="onClicQuitaruser(usuarioBean.usuario)" aria-label="Eliminar usuario">
                  <mat-icon>delete</mat-icon>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
  </div>

  <footer class="fise-form-modal__footer" mat-dialog-actions>
    <button type="button" mat-raised-button class="app-form-btn app-form-btn--secondary fise-form-modal__cancel" (click)="onClicCerrarModal()">Cancelar</button>
    <button type="button" mat-raised-button class="app-form-btn app-form-btn--primary fise-form-modal__save" (click)="onClicGuardar()" [disabled]="formGroupServidor.invalid || listUsuarios.length === 0">
      <mat-icon>save</mat-icon>
      Guardar
    </button>
  </footer>
</section>
